import {
  AdminCancelledLocationList,
  AdminCancelledLocationSearchFilter,
} from '@exam-center/exam-location-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, PaperSection } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function PermissionRequiredExamLocationManagementCancellationsPage() {
  return (
    <PermissionGuard
      requiredPermission={[
        APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW,
      ]}
    >
      <ExamLocationManagementCancellationsPage />
    </PermissionGuard>
  );
}

function ExamLocationManagementCancellationsPage() {
  return (
    <PaperSection title='ยกเลิกการใช้งาน'>
      <Flex
        sx={(theme) => ({
          flexDirection: 'column',
          gap: theme.spacing(4),
          p: theme.spacing(6),
        })}
      >
        <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(4) })}>
          <AdminCancelledLocationSearchFilter />
          <AdminCancelledLocationList />
        </Flex>
      </Flex>
    </PaperSection>
  );
}
